(function($, document, window, undefined) {
	$(function() {
		var redirect = localStorage.getItem("location-redirect"),
			messageWrap = $("#location-redirect-message"),
			currentCountry = $('.current_country', messageWrap),
			redirectFromCountries = "FR",
			countryTranslations = {
				"Sweden": "Sverige"
			};

		redirect = (typeof redirect == "string") ? JSON.parse(redirect) : {shown: false, date: null};

		var today = new Date(),
			prevDate = new Date(redirect.date),
			dayLength = 1000 * 24 * 60 * 60, // in milliseconds
			diffDate = today - prevDate;

		// display query again if localStorage is older than 30 days
		if( diffDate / dayLength > 30 )
			redirect.shown = false;

		if( !redirect.shown ) {
			$.ajax( {
				url: 'https://freegeoip.net/json/',
				type: 'POST',
				dataType: 'jsonp',
				success: function(location) {
					if (redirectFromCountries.indexOf(location.country_code) !== -1) {
						var countryName = (countryTranslations[location.country_name]) ? countryTranslations[location.country_name] : location.country_name;
						currentCountry.text(countryName);
						$("#location-redirect-message").show();
					}
				}
			});

			$('.close-redirect-btn').on("click", function(e) {
				e.preventDefault();
                e.stopPropagation();
				$('#location-redirect-message').hide();
				saveRedirect();
			});

			$('.redirect-me').on("click", function(e) {
				e.stopPropagation();
				saveRedirect();
			});

		} // /if !redirectShown

	});
})(jQuery, document, window);

function saveRedirect(key, val) {
	var redirect = {
		shown: true,
		date: Date()
	};
	localStorage.setItem("location-redirect", (JSON.stringify(redirect)));
}